/**
 * Identificador de build de la UI (cambia con REACT_APP_UI_BUILD_ID en CI o al desplegar).
 * Si no coincide con lo que ves en pantalla, el navegador está sirviendo otro bundle o :8000 + frontend_build.
 */
export const VF_UI_BUILD_ID = process.env.REACT_APP_UI_BUILD_ID || "2026-05-31-module-toolbar-v1";
